// Wait for the entire document content to be loaded
document.addEventListener('DOMContentLoaded', function() {
    
    // 0. SCOPE CHECK: Ensure this script only runs on product detail pages for efficiency.
    if (!window.location.pathname.includes('/products/')) {
        return; 
    }
    
    // 1. Target the answer container of the VERY FIRST tab.
    // We use the precise class names found via inspection to guarantee we hit the correct element.
    const firstTabAnswer = document.querySelector('.grid-template--20788451443022__ss_tabs_block_CATbc .faq-template--20788451443022__ss_tabs_block_CATbc:first-child .answer-template--20788451443022__ss_tabs_block_CATbc');

    // 2. Target the arrow icon to visually indicate the tab is open (Optional but recommended)
    const firstTabArrow = document.querySelector('.grid-template--20788451443022__ss_tabs_block_CATbc .faq-template--20788451443022__ss_tabs_block_CATbc:first-child .icon-template--20788451443022__ss_tabs_block_CATbc');

    if (firstTabAnswer) {
        
        // 3. Directly override the 'display: none' and 'height: 0px' styles set by the app on load.
        // We rely on this JS to load late and override the initial inline style.
        firstTabAnswer.style.display = 'block';
        firstTabAnswer.style.height = 'auto'; // Allows content height to control the box size
        
        // Re-apply a sensible top/bottom padding to match your theme's default look
        firstTabAnswer.style.paddingTop = '15px';
        firstTabAnswer.style.paddingBottom = '15px';
        
        // 4. Update the arrow icon's custom CSS variable to show the 'open' state (180 degrees)
        if (firstTabArrow) {
             firstTabArrow.style.setProperty('--rotate', '180deg');
        }
    }
});